<template>
  <el-radio-group v-model="radio" @change="getsctType">
    <el-radio :label="0">选修</el-radio>
    <el-radio :label="1">必修</el-radio>
  </el-radio-group>
</template>

<script>
import { BaseVue } from "@/mixin/index";

export default {
  name: "StudyclassTypeSelect",
  
  mixins: [BaseVue],
  
  props: {
    StudyClassTypeType: {
      type: [String, Number],
      default: null
    }
  },
  
  data() {
    return {
      radio: 0
    };
  },
  
  methods: {
    getsctType(e) {
      this.$emit('getsctType', e);
    }
  },
  
  watch: {
    StudyClassTypeType: {
      handler(newVal) {
        this.radio = newVal;
      },
      immediate: true
    }
  }
};
</script>